<template>
  <WdsText size="sm" color="gray-500">
    {{ displayDate }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const PaymentRequestBillingStartDateColumn = graphql(`
  fragment PaymentRequestBillingStartDateColumn on PaymentRequest {
    id
    startDate
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestBillingStartDateColumn>
}>()

const column = computed(() => useFragment(PaymentRequestBillingStartDateColumn, props.row))

const formattedDate = useDate(
  computed(() => column.value.startDate),
  'MMM D, YYYY',
)

const displayDate = computed(() =>
  formattedDate.isValid.value ? formattedDate.date.value : '-',
)
</script>

